var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3359 18.3307H15.0026C15.4446 18.3307 15.8686 18.1551 16.1811 17.8426C16.4937 17.53 16.6693 17.1061 16.6693 16.6641V6.66407C16.6699 6.39999 16.6183 6.1384 16.5173 5.8944C16.4163 5.65039 16.268 5.4288 16.0809 5.2424L13.0909 2.2524C12.9045 2.06534 12.683 1.91703 12.4389 1.81606C12.1949 1.71508 11.9333 1.66342 11.6693 1.66407H5.0026C4.56058 1.66407 4.13665 1.83966 3.82409 2.15222C3.51153 2.46478 3.33594 2.88871 3.33594 3.33074V5.70574",
    stroke: "#67768E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 18.3359C9.42549 18.3359 11.6641 16.0974 11.6641 13.3359C11.6641 10.5745 9.42549 8.33594 6.66406 8.33594C3.90264 8.33594 1.66406 10.5745 1.66406 13.3359C1.66406 16.0974 3.90264 18.3359 6.66406 18.3359Z",
    fill: "#5D5FEF",
    stroke: "#5D5FEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 1.66406V5.83073C11.6641 6.05174 11.7519 6.2637 11.9081 6.41998C12.0644 6.57626 12.2764 6.66406 12.4974 6.66406H16.6641",
    stroke: "#67768E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 11.6641V13.4974L7.9974 14.3307",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileClock);
export default __webpack_public_path__ + "static/media/fileClock.3784b3f7693578e466086f2a59729964.svg";
export { ForwardRef as ReactComponent };